import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import SavableFormLabel from './SavableFormLabel';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ReasonForEscalationSelect(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavableFormLabel, {
      "data-test-id": "reason-for-escalation-select-label",
      isSaving: props.isSaving,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.reasonForEscalation.label"
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "reason-for-escalation-select-select",
      onChange: ({
        target: {
          value
        }
      }) => props.onSelect(value),
      options: props.options,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.reasonForEscalation.placeholder"
      }),
      value: props.selectedOption
    })]
  });
}
ReasonForEscalationSelect.propTypes = {
  isSaving: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.number
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ReasonForEscalationSelect.defaultProps = {
  isSaving: false,
  selectedOption: undefined
};
export default ReasonForEscalationSelect;